





import { Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax'
import AbpBase from '../../lib/abpbase'
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend');
@Component({})
export default class Bar extends AbpBase{
    @Prop({type:Object}) value:Object;
    initData:any = {
        app:{},
        data:{}
    }
    drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('myChart'));
        // 绘制图表
        this.initData.app.config = {
            rotate: 90,
            align: 'left',
            verticalAlign: 'middle',
            position: 'insideBottom',
            distance: 10,
            onChange: function () {
                var labelOption = {
                    normal: {
                        rotate: this.initData.app.config.rotate,
                        align: this.initData.app.config.align,
                        verticalAlign: this.initData.app.config.verticalAlign,
                        position: this.initData.app.config.position,
                        distance: this.initData.app.config.distance
                    }
                };
                myChart.setOption({
                    series: [{
                        label: labelOption
                    }, {
                        label: labelOption
                    }, {
                        label: labelOption
                    }, {
                        label: labelOption
                    }]
                });
            }
        };
        var labelOption = {
            normal: {
                show: true,
                position: this.initData.app.config.position,
                distance: this.initData.app.config.distance,
                align: this.initData.app.config.align,
                verticalAlign: this.initData.app.config.verticalAlign,
                rotate: this.initData.app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 12,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            }
        };
        myChart.setOption({
            color: ['#67e0e3', '#32c5e9', '#37a2da', '#ff9f7f','#9fe6b8'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: ['项目总经费', '已收款金额', '未收款金额', '开票未收款金额','利润']
            },
            grid: {
                right: '1%',
                left:'5%',
            },
            calculable: true,
            axisLabel : {//坐标轴刻度标签的相关设置。
                formatter : function(params:any){
                var newParamsName = "";// 最终拼接成的字符串
                            var paramsNameNumber = params.length;// 实际标签的个数
                            var provideNumber = 4;// 每行能显示的字的个数
                            var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
                            /**
                             * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                             */
                            // 条件等同于rowNumber>1
                            if (paramsNameNumber > provideNumber) {
                                /** 循环每一行,p表示行 */
                                for (var p = 0; p < rowNumber; p++) {
                                    var tempStr = "";// 表示每一次截取的字符串
                                    var start = p * provideNumber;// 开始截取的位置
                                    var end = start + provideNumber;// 结束截取的位置
                                    // 此处特殊处理最后一行的索引值
                                    if (p == rowNumber - 1) {
                                        // 最后一次不换行
                                        tempStr = params.substring(start, paramsNameNumber);
                                    } else {
                                        // 每一次拼接字符串并换行
                                        tempStr = params.substring(start, end) + "\n";
                                    }
                                    newParamsName += tempStr;// 最终拼成的字符串
                                }

                            } else {
                                // 将旧标签的值赋给新标签
                                newParamsName = params;
                            }
                            //将最终的字符串返回
                            return newParamsName
                }

            },
            xAxis: [
                {
                    type: 'category',
                    axisTick: {show: false},
                    data: this.initData.data['name']
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '项目总经费（元）',
                    type: 'bar',
                    barGap: 0,
                    label: labelOption,
                    data:  this.initData.data['projectAmountTotal']
                },
                {
                    name: '已收款（元）',
                    type: 'bar',
                    label: labelOption,
                    data: this.initData.data['receivedAmountTotal']
                },
                {
                    name: '未收款（元）',
                    type: 'bar',
                    label: labelOption,
                    data: this.initData.data['unReceivedAmountTotal']
                },
                {
                    name: '开票未收款（元）',
                    type: 'bar',
                    label: labelOption,
                    data: this.initData.data['ticketUnReceiveAmountTotal']
                },
                {
                    name: '利润（元）',
                    type: 'bar',
                    label: labelOption,
                    data: this.initData.data['profitAmount']
                }
            ]
        });
    }
    mounted(){
        this.drawLine();
        window.addEventListener('resize', () => {
            echarts.init(document.getElementById('myChart')).resize() //初始化的
        } )
    }
    @Watch('value',{ immediate: true,deep: true})
    ChangeBar(newValue:any,oldValue:any){
        this.initData.data = newValue;
        this.$nextTick( ()=>{
            this.drawLine();
        } )
    }
}
